import { render, staticRenderFns } from "./StateList.vue?vue&type=template&id=5c20c447"
import script from "./StateList.vue?vue&type=script&lang=js"
export * from "./StateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports